package kpt.core.database.economic

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.Double
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class InterestRateSeriesDao_Impl(
  __db: RoomDatabase,
) : InterestRateSeriesDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfInterestRateSeriesEntity:
      EntityInsertAdapter<InterestRateSeriesEntity>
  init {
    this.__db = __db
    this.__insertAdapterOfInterestRateSeriesEntity = object : EntityInsertAdapter<InterestRateSeriesEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `interest_rate_series` (`seriesId`,`date`,`value`,`updatedAt`) VALUES (?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: InterestRateSeriesEntity) {
        statement.bindText(1, entity.seriesId)
        statement.bindText(2, entity.date)
        statement.bindDouble(3, entity.value)
        statement.bindLong(4, entity.updatedAt)
      }
    }
  }

  public override suspend fun upsertAll(entries: List<InterestRateSeriesEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfInterestRateSeriesEntity.insert(_connection, entries)
  }

  public override suspend fun upsert(entry: InterestRateSeriesEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfInterestRateSeriesEntity.insert(_connection, entry)
  }

  public override fun observeBySeriesId(seriesId: String): Flow<List<InterestRateSeriesEntity>> {
    val _sql: String = "SELECT * FROM interest_rate_series WHERE seriesId = ? ORDER BY date DESC"
    return createFlow(__db, false, arrayOf("interest_rate_series")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, seriesId)
        val _columnIndexOfSeriesId: Int = getColumnIndexOrThrow(_stmt, "seriesId")
        val _columnIndexOfDate: Int = getColumnIndexOrThrow(_stmt, "date")
        val _columnIndexOfValue: Int = getColumnIndexOrThrow(_stmt, "value")
        val _columnIndexOfUpdatedAt: Int = getColumnIndexOrThrow(_stmt, "updatedAt")
        val _result: MutableList<InterestRateSeriesEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: InterestRateSeriesEntity
          val _tmpSeriesId: String
          _tmpSeriesId = _stmt.getText(_columnIndexOfSeriesId)
          val _tmpDate: String
          _tmpDate = _stmt.getText(_columnIndexOfDate)
          val _tmpValue: Double
          _tmpValue = _stmt.getDouble(_columnIndexOfValue)
          val _tmpUpdatedAt: Long
          _tmpUpdatedAt = _stmt.getLong(_columnIndexOfUpdatedAt)
          _item = InterestRateSeriesEntity(_tmpSeriesId,_tmpDate,_tmpValue,_tmpUpdatedAt)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeAll(): Flow<List<InterestRateSeriesEntity>> {
    val _sql: String = "SELECT * FROM interest_rate_series ORDER BY date DESC"
    return createFlow(__db, false, arrayOf("interest_rate_series")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfSeriesId: Int = getColumnIndexOrThrow(_stmt, "seriesId")
        val _columnIndexOfDate: Int = getColumnIndexOrThrow(_stmt, "date")
        val _columnIndexOfValue: Int = getColumnIndexOrThrow(_stmt, "value")
        val _columnIndexOfUpdatedAt: Int = getColumnIndexOrThrow(_stmt, "updatedAt")
        val _result: MutableList<InterestRateSeriesEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: InterestRateSeriesEntity
          val _tmpSeriesId: String
          _tmpSeriesId = _stmt.getText(_columnIndexOfSeriesId)
          val _tmpDate: String
          _tmpDate = _stmt.getText(_columnIndexOfDate)
          val _tmpValue: Double
          _tmpValue = _stmt.getDouble(_columnIndexOfValue)
          val _tmpUpdatedAt: Long
          _tmpUpdatedAt = _stmt.getLong(_columnIndexOfUpdatedAt)
          _item = InterestRateSeriesEntity(_tmpSeriesId,_tmpDate,_tmpValue,_tmpUpdatedAt)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteBySeriesId(seriesId: String) {
    val _sql: String = "DELETE FROM interest_rate_series WHERE seriesId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, seriesId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM interest_rate_series"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
